import { LogOut } from "lucide-react";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../features/auth/user.reducer";

const LogoutModal = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success] = useState(false);

  const openLogoutModal = () => {
    setIsModalVisible(true);
  };
  const closeLogoutModal = () => {
    setIsModalVisible(false);
    setError(null);
  };

  const newHandleLogout = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      dispatch(logout());
      navigate("/login");
    }, 2000);
  };

  return (
    <div className="settings-option-row flex items-center justify-between p-2 w-full bg-transparent my-5">
      <span className="settings-option-label text-black font-medium text-xl">Sign Out?</span>
      <button
        onClick={openLogoutModal}
        className="settings-option-button settings-action-button px-4 text-xl py-3 rounded-xl font-semibold bg-white text-purple-400 border border-purple-400"
      >
        Sign Out
      </button>

      {isModalVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-xl w-3/4 max-w-md">
            <LogOut color="red" />
            <h2 className="text-2xl font-semibold mb-4 mt-4">Sign out?</h2>
            <p className="text-gray-600 mb-4">
              You will be logged out of your account and redirected to the home
              page.
            </p>

            <div className="flex justify-between gap-10">
              <button
                onClick={newHandleLogout}
                disabled={isLoading}
                className={`bg-gray-900 text-red-600 px-6 py-2 rounded-xl flex-1 ${
                  isLoading ? "opacity-80 cursor-not-allowed" : ""
                }`}
              >
                {isLoading
                  ? "Signing Out..."
                  : success
                  ? "Redirecting..."
                  : "Sign Out"}
              </button>
              <button
                onClick={closeLogoutModal}
                className="px-6 py-2 rounded-xl flex-1 border-2 text-purple-400 border-purple-400"
              >
                Cancel
              </button>
            </div>

            {error && <div className="text-red-500 mt-2">{error}</div>}
            {success && (
              <div className="text-green-500 mt-2">
                Signed out successfully. Redirecting...
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default LogoutModal;
